<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">扣缴申报确认</li>
      <li
        v-if="state.selectIds?.length > 0"
        style="display: flex; align-items: flex-end"
      >
        已选择<strong style="color: #1e90ff; margin: 0 5px">{{
          state.selectIds?.length
        }}</strong
        >条数据
        <el-button
          type="danger"
          :icon="Delete"
          link
          @click="state.selectIds = []"
          style="margin-right: 20px"
        >
          清空已选
        </el-button>
      </li>
      <el-button
        type="primary"
        :icon="Upload"
        link
        :disabled="!state.selectIds?.length > 0"
        @click="onSend"
        v-if="$judge_auth('742')"
        size="large"
        >发送确认邀请
      </el-button>
      <el-button
        type="primary"
        :icon="Download"
        link
        @click="state.showAgent = true"
        v-if="$judge_auth('741')"
      >
        从税局更新数据
      </el-button>
      <el-button
        type="warning"
        link
        icon="Tickets"
        @click.stop="state.showLog = true"
        v-if="$judge_auth('756')"
      >
        操作记录
      </el-button>
    </ul>
    <ul class="c-list-search">
      <el-input
        v-model="state.params.keywords"
        style="width: 300px"
        placeholder="姓名、电话、身份证号、银行卡号"
        clearable
        @clear="
          delete state.params.keywords;
          onLoad();
        "
        @paste.enter="$onKeywordsPaste($event, state.params)"
      ></el-input>
      <div
        class="c-withholdingagent-search-box"
        @click="state.showWithholdingAgent = true"
      >
        <li style="flex: 1; display: flex; column-gap: 5px">
          <template v-if="state.withholding_agent_arr?.length > 0">
            <div
              class="c-withholdingagent-search-tag"
              style="
                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ state.withholding_agent_arr[0]?.name }}
            </div>
            <el-popover
              v-if="state.withholding_agent_arr?.length > 1"
              placement="right"
              width="auto"
              popper-style="max-height: 90vh;overflow-y: auto;"
            >
              <template #reference>
                <div class="c-withholdingagent-search-tag" @click.stop="">
                  {{ "+ " + (state.withholding_agent_arr?.length - 1) }}
                </div>
              </template>
              <template #default>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    row-gap: 5px;
                    width: fit-content;
                  "
                >
                  <ul
                    v-for="(item, index) in state.withholding_agent_arr"
                    :key="item"
                    style="
                      white-space: nowrap;
                      background-color: #f0f2f5;
                      color: var(--el-color-info);
                      border-radius: 4px;
                      font-size: 12px;
                      padding: 0 9px;
                      height: 24px;
                      line-height: 24px;
                      display: flex;
                      align-items: center;
                      column-gap: 10px;
                    "
                  >
                    <li>{{ item.name }}</li>
                    <el-icon
                      @click.stop="state.withholding_agent_arr.splice(index, 1)"
                      color="#a2a2a2"
                      style="cursor: pointer"
                      ><CircleClose
                    /></el-icon>
                  </ul>
                </div>
              </template>
            </el-popover>
          </template>
          <text v-else style="color: #a2a2a2">点击选择扣缴义务人</text>
        </li>
        <el-icon
          v-if="state.withholding_agent_arr?.length > 0"
          @click.stop="delete state.withholding_agent_arr"
          color="#a2a2a2"
          ><CircleClose
        /></el-icon>
      </div>
      <el-select
        v-model="state.params.customer_id"
        placeholder="所属客户"
        style="width: 300px"
      >
        <el-option
          v-for="item in state.customerData"
          :key="item.id"
          :label="item.alias + '(' + item.name + ')'"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadCustomer()"> 刷新 </el-button>
        </template>
      </el-select>
      <el-date-picker
        v-model="state.params.skssq"
        type="month"
        placeholder="税款所属期"
        value-format="YYYYMM"
        format="YYYY年M月"
        style="width: 140px"
      />
      <c_statusselect
        v-model="state.params.zt"
        arrName="declareconfirm_zt"
        placeholder="发送状态"
        width="120"
        @change="onLoad"
        :key="state.key"
      ></c_statusselect>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-checkbox-group
        v-model="state.selectIds"
        style="flex: 1; display: flex; flex-direction: column; overflow: hidden"
      >
        <el-table
          ref="tableDom"
          :data="state.tableData"
          v-loading="!Array.isArray(state.tableData)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          :default-sort="{
            prop: state.params.sort_field,
            order:
              state.params.sort_value == 'desc' ? 'descending' : 'ascending',
          }"
          @sort-change="onSortChange"
          @row-click="onRowClick"
        >
          <el-table-column width="55" fixed @click.stop="">
            <template #header>
              <el-checkbox :value="-1" @change="onSelect($event, -1)" />
            </template>
            <template #default="{ row }">
              <el-checkbox
                :value="row.id"
                @change="onRowClick(row)"
                :disabled="row.collected_status == 2"
              />
            </template>
          </el-table-column>
          <el-table-column
            fixed
            label="序号"
            width="70"
            type="index"
            :index="
              (index) =>
                (state.params.page - 1) * state.params.limit + index + 1
            "
            align="center"
          />
          <el-table-column
            prop="xm"
            label="姓名"
            :formatter="
              (row, column, cellValue) =>
                $tab_Highlinght(cellValue, state.params.keywords)
            "
            width="100"
            fixed
          />
          <el-table-column
            prop="lxdh"
            label="手机号"
            :formatter="
              (row, column, cellValue) =>
                $tab_Highlinght(cellValue, state.params.keywords)
            "
            width="120"
          >
            <template #default="{ row }">
              <text
                style="color: #1e90ff"
                class="text-hover-decoration"
                title="手机号"
                @click="$onCopy(row.lxdh)"
                v-if="row.lxdh"
              >
                {{ row.lxdh }}
              </text>
              <text v-else>-</text>
            </template>
          </el-table-column>
          <el-table-column
            prop="zzhm"
            label="证件号"
            :formatter="
              (row, column, cellValue) =>
                $tab_Highlinght(cellValue, state.params.keywords)
            "
            width="180"
          >
            <template #default="{ row }">
              <text
                style="color: #1e90ff"
                class="text-hover-decoration"
                title="证件号"
                @click="$onCopy(row.zzhm)"
              >
                {{ row.zzhm }}
              </text>
            </template>
          </el-table-column>
          <el-table-column
            prop="zzlx"
            label="证件类型"
            :formatter="$tab_TextFormat"
            width="120"
          />
          <el-table-column
            prop="withholding_agent_name"
            label="扣缴义务人"
            :formatter="$tab_TextFormat"
            min-width="240"
          >
            <template #default="{ row }">
              <div
                :data-type="row.withholding_agent_type == 1 ? '供' : '扣'"
                :style="{
                  '--dynamic-color':
                    row.withholding_agent_type == 1 ? '#1e90ff' : '#ffa500',
                }"
                class="withholding-badge"
              >
                {{ row.withholding_agent_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="统一社会信用代码" width="220">
            <template #default="{ row }">
              <text
                style="color: #1e90ff"
                class="text-hover-decoration"
                @click.stop="$onCopy(row.unified_social_credit_identifier)"
                v-if="row.unified_social_credit_identifier"
              >
                {{ row.unified_social_credit_identifier }}
              </text>
              <text v-else>-</text>
            </template>
          </el-table-column>
          <el-table-column
            prop="skssq"
            label="税款所属期"
            :formatter="$tab_TextFormat"
            width="120"
          />
          <el-table-column
            prop="sblx_name"
            label="申报类型"
            :formatter="$tab_ShowToolTip"
            min-width="220"
          />
          <el-table-column label="状态" sortable="zt" width="100">
            <template #default="{ row }">
              <c_status arrName="declareconfirm_zt" :value="row.zt" />
            </template>
          </el-table-column>
          <el-table-column
            prop="query_fknr"
            label="反馈内容"
            :formatter="$tab_ShowToolTip"
            min-width="220"
          />
          <el-table-column
            prop="sssj"
            label="申诉时间"
            :formatter="$tab_ShowToolTip"
            min-width="220"
          />
          <el-table-column
            prop="fkrq"
            label="反馈日期"
            :formatter="$tab_ShowToolTip"
            min-width="220"
          />
          <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right"
          >
            <template #default="{ row }">
              <el-button
                type="primary"
                link
                icon="Upload"
                @click.stop="onSendSingle(row)"
                :disabled="row.zt != 0"
                :title="row.id"
              >
                发送
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-checkbox-group>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showAgent"
        title="从税局获取员工申报确认列表"
        @close="state.showAgent = false"
      >
        <c_DeclareConfirmSelectWithholdingAgent
          :skssq="state.params.skssq"
          v-if="state.showAgent"
          @close="state.showAgent = false"
          @confirm="onSelectConfirm"
        ></c_DeclareConfirmSelectWithholdingAgent>
      </c_popup>
    </transition>
    <el-drawer v-model="state.showLog" title="操作记录" size="70%">
      <c_DeclareConfirmLog></c_DeclareConfirmLog>
    </el-drawer>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showWithholdingAgent"
        title="选择扣缴义务人"
        @close="state.showWithholdingAgent = false"
      >
        <c_WithholdingAgentSelect
          @close="
            (arr) => {
              state.withholding_agent_arr = arr;
              state.showWithholdingAgent = false;
            }
          "
          :selectItems="state.withholding_agent_arr"
        ></c_WithholdingAgentSelect>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  declareconfirm_list,
  declareconfirm_send,
} from "@/http/declareconfirm";
import {
  data_withholdingagent_select,
  data_customer_select,
} from "@/http/data";
import { dayjs, ElMessageBox, ElMessage } from "element-plus";

class InitFormData {
  params = {
    limit: 100,
    page: 1,
  };
}
export default {
  setup() {
    const tableDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
      selectIds: [],
      withholding_agent_arr: [],
    });
    onMounted(() => {
      state.params.skssq = dayjs().subtract(1, "month").format("YYYYMM");

      onLoadWithholdingAgent();
      onLoadCustomer();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      if (state.withholding_agent_arr?.length > 0)
        state.params.withholding_agent_id = state.withholding_agent_arr
          ?.map((m) => m.id)
          .join(",");
      else delete state.params.withholding_agent_id;

      if (state.rzDates?.length > 0)
        state.params.entry_time = state.rzDates.join(" - ");
      else delete state.params.entry_time;

      if (state.lzDates?.length > 0)
        state.params.resignation_time = state.lzDates.join(" - ");
      else delete state.params.resignation_time;

      declareconfirm_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;

          state.selectIds = state.selectIds.filter((w) => w != -1);
        }
      });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    //加载扣缴义务人和供应商
    const onLoadWithholdingAgent = () => {
      data_withholdingagent_select().then((res) => {
        if (res.status == 200)
          state.withholdingagent_data = res.data.data?.list;
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      state.key = Math.random();
      delete state.withholding_agent_arr;
      delete state.lzDates;
      delete state.rzDates;
      onLoad();
    };

    const onSelect = (checked, item) => {
      if (item == -1) {
        if (checked) {
          state.selectIds = [
            ...state.selectIds,
            ...state.tableData
              .filter(
                (w) =>
                  w.collected_status != 2 && !state.selectIds.includes(w.id)
              )
              .map((m) => m.id),
          ];
        } else {
          state.selectIds = state.selectIds.filter(
            (w) => !state.tableData.map((m) => m.id).includes(w)
          );
        }
      }
    };

    const onRowClick = (item) => {
      if (state.selectIds?.includes(item.id)) {
        state.selectIds = state.selectIds.filter((w) => w != item.id);
      } else state.selectIds.push(item.id);
    };

    const onSend = () => {
      ElMessageBox.confirm(
        `您本次选择了<strong style='color:#f00'>${state.selectIds.length}</strong>条数据，是否立即<strong style='color:#ffa500'>发送确认邀请</strong>？`,
        "发送确认邀请",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定邀请",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        declareconfirm_send({ id: state.selectIds.join(",") }).then((res) => {
          if (res.status == 200) {
            ElMessage({
              type: "success",
              message: res.data.msg,
              dangerouslyUseHTMLString: true,
            });
            onLoad();
          }
        });
      });
    };

    const onSendSingle = (row) => {
      ElMessageBox.confirm(
        `您确定给员工<strong style='color:#080'>${row.xm}</strong><strong style='color:#ffa500'>发送确认邀请</strong>吗？`,
        "发送确认邀请",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定邀请",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        declareconfirm_send({ id: row.id }).then((res) => {
          if (res.status == 200) {
            ElMessage({
              type: "success",
              message: res.data.msg,
              dangerouslyUseHTMLString: true,
            });
            onLoad();
          }
        });
      });
    };

    return {
      state,
      tableDom,
      onLoad,
      onSortChange,
      onReset,
      onLoadCustomer,
      onLoadWithholdingAgent,
      onRowClick,
      onSelect,
      onSend,
      onSendSingle,
    };
  },
};
</script>
<style scoped></style>
